(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
}(function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  module.exports =
  /*#__PURE__*/
  function () {
    function SecurityCentro() {
      _classCallCheck(this, SecurityCentro);

      this.scUrl = 'https://sc.centro.services:443';
      this.manager = null;

      this._initLocalAuth(); // Init localy saved manager


      this.filesCollection = [];
    }

    _createClass(SecurityCentro, [{
      key: "setUserId",
      value: function setUserId(userId) {
        this.userId = userId;
      }
    }, {
      key: "setData",
      value: function setData(data) {
        this.dataCollection = this._makeFormattedParams(data);
      }
    }, {
      key: "setFileUrls",
      value: function setFileUrls(fileUrls) {
        this.filesUrlCollection = this._makeFormattedParams(fileUrls);
      }
    }, {
      key: "setFilesByAlias",
      value: function setFilesByAlias(alias, base64Data) {
        this.filesCollection[alias] = base64Data;
      }
      /**
       * @todo need tests
       * @param password
       */

    }, {
      key: "setUserCredentials",
      value: function setUserCredentials(password) {
        this.authPassword = password;
        return this._makeAuth();
      }
    }, {
      key: "setManagerCredentials",
      value: function setManagerCredentials(managerId, password) {
        this.manager = managerId;
        this.authPassword = password;
        return this._makeAuth();
      }
      /**
       * Can check if we need ask for credentials.
       * Return TRUE if we need set new credentials.
       * @returns bool
       */

    }, {
      key: "needAuth",
      value: function needAuth() {
        if (!(this.manager || this.userId)) {
          return true;
        }

        var expTime = sessionStorage.getItem(this._getLocalSessionName());
        var sca = sessionStorage.getItem('sca');

        if (this._getLocalSessionName() === null || expTime === null || !sca) {
          return true;
        }

        return parseInt(expTime) - Math.round(+new Date() / 1000) < 20; // if session can last less then 20 sec, then we need auth
      }
      /**
       * @todo we can set multiply aliases in one request,
       * @param array requestedArray of aliases
       */

    }, {
      key: "getArray",
      value: function getArray(requestedArray) {
        if (Array.isArray(requestedArray)) {
          return this.getByAlias(requestedArray);
        } else {
          throw new Error('requestedArray should be array');
        }
      }
    }, {
      key: "getByAlias",
      value: function getByAlias(alias) {
        var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'decrypt';
        var getResult = this.get(this._getBaseParams(alias), method);

        if (200 > getResult.code > 100) {
          return false;
        }

        if (Array.isArray(alias)) {
          var _return = {};

          for (var key in alias) {
            _return[alias[key]] = getResult[alias[key]]; // get info without system information
          }

          return _return;
        }

        return getResult[alias];
      }
    }, {
      key: "_createUser",
      value: function _createUser(key) {
        var _this = this;

        return new Promise(function (resolve) {
          resolve(_this.get({
            userPassword: key
          }, 'createUser'));
        }).then(function (res) {
          if (res.status === true) _this.setUserCredentials(key);
          return res;
        })["catch"](function (err) {
          console.error(err);
        });
      }
      /**
       * Synchronous
       * @param params
       * @param method
       * @returns {*}
       */

    }, {
      key: "get",
      value: function get() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'decrypt';
        params['userId'] = this.userId;

        var returnResult = this._makeSyncRequest(this._composeParamsForRequest(params, method));

        return returnResult;
      }
      /**
       * Send text data and files to SecurityCentro
       * @returns {Promise<T | never>}
       */

    }, {
      key: "runDataSending",
      value: function runDataSending() {
        var _this2 = this;

        this.errors = [];

        var scObject = this;
        /**
         * Send Input Fields
         */

        return new Promise(function (resolve, reject) {
          return scObject._sendData(scObject._composeParamsForRequest(scObject._getBaseParams(false, scObject._convertCollectionToAssoc(_this2.dataCollection)), 'encrypt'), scObject.scUrl, null, scObject).then(function (response) {
            resolve();
          });
        }).then(function (results) {
          /**
           * Read file by url from scObject.filesUrlCollection array and fill filesCollection array with base64 data
           */
          return Promise.all(scObject.filesUrlCollection.map(function (value) {
            return new Promise(function (resolve, reject) {
              var request = new XMLHttpRequest();
              request.open('GET', value.data);
              request.responseType = 'blob'; // When the request loads, check whether it was successful

              request.onload = function () {
                if (request.status === 200) {
                  resolve(request.response);
                } else {
                  reject(new Error('Image didn\'t load successfully; error code:' + request.statusText));
                }
              };

              request.onerror = function () {
                reject(new Error('There was a network error.'));
              };

              request.send();
            }).then(function (results) {
              var reader = new FileReader();
              return new Promise(function (resolve, reject) {
                reader.onload = function (event) {
                  scObject.setFilesByAlias(value.alias, event.target.result.split(',')[1]);
                  resolve();
                };

                reader.onerror = function () {
                  reject('file reading error');
                };

                reader.readAsDataURL(results);
              });
            });
          }));
          /**
           *  Send file to sc
           */
        }).then(function () {
          return scObject._sendData(scObject._composeParamsForRequest(scObject._getBaseParams(false, _this2.filesCollection), // scObject._getBaseParams(value.alias, results),
          'encrypt'), scObject.scUrl, null)["catch"](function () {
            throw new Error('Error while sending image to SC');
          });
        })["catch"](function (err) {
          console.log('Catch: ', err);
          throw new Error('Error:' + err);
        });
      }
    }, {
      key: "_sendData",
      value: function _sendData(params, url, alias, scope) {
        var _this3 = this;

        var method = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'POST';
        return new Promise(function (resolve, reject) {
          var formData = new FormData();

          for (var key in params) {
            formData.append(key, params[key]);
          }

          var xhr = new XMLHttpRequest();
          xhr.open(method, url, true);
          xhr.withCredentials = true;
          var sca = sessionStorage.getItem('sca');

          if (!!sca) {
            xhr.setRequestHeader('sca', sca);
          }

          xhr.onerror = function () {
            throw new Error('Network Error');
          };

          xhr.onload = function () {
            if (xhr.readyState === 4) {
              resolve(_this3._getXhrResponse(xhr, alias));
            } else {
              reject('Data sending error');
            }
          };

          xhr.send(formData);
        });
      }
    }, {
      key: "_getBaseParams",
      value: function _getBaseParams(alias) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var params = [];
        params['userId'] = this.userId;

        if (Array.isArray(data)) {
          params['alias'] = Object.assign({}, alias);
        } else if (alias !== false) {
          params['alias'] = alias;
        }

        if (Array.isArray(data)) {
          params['data'] = Object.assign({}, data);
        } else if (data != '') {
          params['data'] = data;
        }

        return params;
      }
    }, {
      key: "_getXhrResponse",
      value: function _getXhrResponse(xhr, alias) {
        if (xhr.status == 200) {
          var decoded = JSON.parse(xhr.response);
          /**
           * SC Errors
           */

          this.errors = [];

          if (decoded.code != 0) {
            if (alias === null) {
              alias = 'n/a';
            }

            this.errors[alias] = [decoded.code, decoded.result];
          }

          if (decoded.status != true) {
            throw new Error('Wrong request');
          }

          return decoded;
        } else {
          throw new Error('http status not 200; Status:' + this.status);
        }
      }
    }, {
      key: "_composeParamsForRequest",
      value: function _composeParamsForRequest(params, method) {
        var requestParams = [];
        requestParams['params'] = JSON.stringify(Object.assign({}, params, this._getRequestCredentials()) // merge with credentials
        );
        requestParams['method'] = method;
        return requestParams;
      }
      /**
       * @todo maybe combine with XMLHttpRequest above
       * @param params
       * @param alias
       * @returns '' OR decoded result for current alias
       */

    }, {
      key: "_makeSyncRequest",
      value: function _makeSyncRequest(params) {
        var formData = new FormData();

        for (var key in params) {
          formData.append(key, params[key]);
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", this.scUrl, false);
        xhr.withCredentials = true;
        var sca = sessionStorage.getItem('sca');

        if (!!sca) {
          xhr.setRequestHeader('sca', sca);
        }

        xhr.send(formData);
        return JSON.parse(xhr.responseText);
      }
    }, {
      key: "_makeAuth",
      value: function _makeAuth() {
        var getResult = this.get([], 'auth');

        if (getResult !== null && getResult.lifetime > 0) {
          return this._saveAuthLocaly(Math.round(+new Date() / 1000) + getResult.lifetime, getResult.result);
        }

        return false;
      }
    }, {
      key: "_saveAuthLocaly",
      value: function _saveAuthLocaly(expireTimestamp, hash) {
        if (typeof this.manager !== 'undefined' && this.manager !== null) {
          sessionStorage.setItem('managerId', this.manager);
        } else if (typeof this.userId !== 'undefined' && this.userId !== null) {
          sessionStorage.setItem('userId', this.userId);
        } else {
          throw new Error('Empty credentials');
        }

        sessionStorage.setItem('sca', hash);
        sessionStorage.setItem(this._getLocalSessionName(), parseInt(expireTimestamp));
        return true;
      }
    }, {
      key: "_getLocalSessionName",
      value: function _getLocalSessionName() {
        if (this.manager !== null) {
          return "sc-expTime-" + this.manager;
        } else if (sessionStorage.getItem('userId') !== null) {
          return "sc-expTime-" + this.userId;
        }

        return null;
      }
    }, {
      key: "_initLocalAuth",
      value: function _initLocalAuth() {
        if (sessionStorage.getItem('managerId') !== null) {
          this.manager = sessionStorage.getItem('managerId');
        }
      }
      /**
       * @returns {Array}
       */

    }, {
      key: "_getRequestCredentials",
      value: function _getRequestCredentials() {
        var cred = [];

        if (this.manager !== null) {
          cred['managerId'] = this.manager;
        }

        if (this.authPassword !== null) {
          cred['password'] = this.authPassword;
        }

        if (typeof this.userId === 'undefined' || this.userId === null) {
          throw new Error('Empty requested user');
        } else {
          cred['userId'] = this.userId;
        }

        return cred;
      }
      /*
      *   @param array data Format: ['someAlias1' => 'someData1', 'someAlias2' => 'someData2']
      *                          OR [0 => ['alias' => 'someAlias1', 'data' => 'someData1'], 1 => ['alias' => 'someAlias2', 'data' => 'someData2']]
      */

    }, {
      key: "_makeFormattedParams",
      value: function _makeFormattedParams(data) {
        var formattedParams = [];

        for (var key in data) {
          if (isFinite(key)) {
            if (typeof data[key].alias === 'undefined' || typeof data[key].data === 'undefined') {
              throw new Error('wrong input format');
            }

            formattedParams.push(data[key]);
          } else {
            var temp = [];
            temp['alias'] = key;
            temp['data'] = data[key];
            formattedParams.push(temp);
          }
        }

        return formattedParams;
      }
    }, {
      key: "_convertCollectionToAssoc",
      value: function _convertCollectionToAssoc(data) {
        var _temp = [];

        for (var key in data) {
          _temp[data[key]['alias']] = data[key]['data'];
        }

        return _temp;
      }
    }, {
      key: "_getKey",
      value: function _getKey() {
        var length = 16,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-=_@#$%",
            retVal = "";

        for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }

        return retVal;
      }
    }]);

    return SecurityCentro;
  }();

}));



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/@centro/security-client/dist/index.js
// module id = 33
// module chunks = 2